import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { PropertyElement } from '../../../../../domain/consts';
import { CalculationSubject, DictionaryType, PropertyType } from '../../../../../domain/dictionary.model';
import {
    InsuredProductProperty,
    PropertyAttribute,
    PropertyFlatElements,
    PropertyHouseElements
} from '../../../../../domain/product.domain';
import { AsideAction } from '../../../store/aside.action';
import { OfferState } from '../../../store/offer.state';

@Component({
    selector: 'app-property-readonly',
    templateUrl: './property-readonly.component.html',
    styleUrls: ['./property-readonly.component.scss']
})
export class PropertyReadonlyComponent implements OnInit, OnDestroy {

    product: InsuredProductProperty;

    subscriptions: Subscription[] = [];
    dictionaryTypes = DictionaryType;

    calculationSubject = CalculationSubject;

    calculated: InsuredProductProperty;

    attributes = [
        {type: PropertyAttribute.IS_RENTED, label: 'OFFER_CONFIG.IS_RENTED'},
        {type: PropertyAttribute.HAS_SAFE_DOOR, label: 'OFFER_CONFIG.HAS_SAFE_DOOR'},
        {type: PropertyAttribute.HAS_ALARM, label: 'OFFER_CONFIG.HAS_ALARM'},
        {type: PropertyAttribute.IS_UNDER_PROTECTION, label: 'OFFER_CONFIG.IS_UNDER_PROTECTION'},
    ];

    get hasAttribute() {
        for (let i = 0; i < this.attributes.length; i++) {
            if (this.product.configuration.propertyAttributeMap[this.attributes[i].type]) {
                return true;
            }
        }
        return false;
    }

    get elements() {
        const code = this.product.configuration.propertyType
            ? this.product.configuration.propertyType.code
            : PropertyType.HOUSE;
        return code === PropertyType.HOUSE
            ? PropertyHouseElements
            : PropertyFlatElements;
    }


    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(OfferState.getReadonlyProperty).subscribe(product => this.product = product)
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close() {
        this.store.dispatch(AsideAction.CloseRight());
    }

    get continuation() {
        return this.product.configuration.continuation.selected
            ? CalculationSubject.CONTINUATION
            : CalculationSubject.NEW_POLICY;
    }

    get hasMainInsurance() {
        return this.product.configuration.elementList[PropertyElement.PROPERTY].selected
            || this.product.configuration.elementList[PropertyElement.EQUIPMENT].selected
            || this.product.configuration.elementList[PropertyElement.PERSONAL_BELONGING].selected;
    };
}
